








import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { DateDef, DateOptions } from '../../type'
import FieldMixins from './FieldMixins'

@Component
export default class DateControl extends mixins(FieldMixins) {
  get options (): DateOptions {
    return Object.assign(new DateOptions(), this.def?.options)
  }

  get type () {
    return this.options.type
  }

  get props () {
    return {
      disabled: this.disabled,
      type: this.type,
      valueFormat: this.options?.format,
      clearable: this.options?.clearable,
      rangeSeparator: '~',
      startPlaceholder: '请选择开始日期',
      endPlaceholder: '请选择结束日期',
      placeholder: this.options?.placeholder || `请选择${this.def?.label}`,
      pickerOptions: {
        disabledDate: this.options?.disabledDate && this.options?.disabledDate({ form: this.actualForm, rowForm: this.rowForm })
      }
    }
  }

  onChange (val: any) {
    const fn = this.options?.onChange
    if (fn) fn({ value: this.value, form: this.actualForm, rowForm: this.rowForm })
  }

  def!: DateDef
}
